// import { MfaViewState } from "@/pages/containers/mfa-container";
import { createContext } from "react";

export type MFAContextType = {
  viewState: MfaViewState;
  setViewState: (viewState: MfaViewState) => void;
  signature: string | null;
  setSignature: (signature: string | null) => void;
  email: string | undefined | null;
  setEmail: (email: string | null) => void;
};

export enum MfaViewState {
  ENABLE = "enable",
  ADD_EMAIL = "addEmail",
  REQUEST_OTP = "requestOtp",
  SEND_OTP = "sendOtp",
  SUCCESS = "success",
  COMPLETE = "complete",
  DISABLE = "disable",
}

export const MFAContext = createContext<MFAContextType>({
  viewState: MfaViewState.ENABLE,
  setViewState: () => {},
  signature: null,
  setSignature: () => {},
  email: null,
  setEmail: () => {},
});
